import { render, staticRenderFns } from "./bird_info.vue?vue&type=template&id=8dc0cba6&"
import script from "./bird_info.vue?vue&type=script&lang=js&"
export * from "./bird_info.vue?vue&type=script&lang=js&"
import style0 from "./bird_info.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports